export type StorageType = 'local' | 'session';

export const getStorageByType = (type: StorageType) => {
  return type === 'local' ? localStorage : sessionStorage;
};
